export const appendQueryParams = (url, queryParams) => {
  if (!queryParams) return url;

  const [baseUrl, existingParams] = url.split('?');
  const existingParamsObj = new URLSearchParams(existingParams || '');
  const newParamsObj = new URLSearchParams(queryParams);

  // merge parameters, giving priority to newParamsObj
  for (const [key, value] of newParamsObj.entries()) existingParamsObj.set(key, value);

  const finalQueryString = existingParamsObj.toString();

  return finalQueryString ? `${baseUrl}?${finalQueryString}` : baseUrl;
};
